<template>
    <div>
        <div class="card dashcard mb-3">
            
            <div class="card-body">

                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtro" :sync="true" @sync="load()" />
                    </div>

                    <div class="col col-12 col-md-6">
                        <az-input
                            v-if="false"
                            placeholder="Todas as Formas..."
                            icon="fas fa-cash-register"
                            type="select"
                            optionsMode="aql"
                            service="forma_pagamentos.index"
                            optionsData="id_forma_pagamento"
                            optionsDisplay="search"
                            v-model="filtro.id_forma_pagamento" />

                        <az-input
                            placeholder="Selecionar paciente..."
                            icon="fa-solid fa-user-injured fa-fw"
                            type="autocomplete"
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            ref="info_paciente"
                            v-model="paciente"
                            :optimized_ac="true">
                            <template v-slot:buttonposb>
                                <print-export printid="lista-impressao" :left="true" />
                            </template>
                        </az-input>
                    </div>

                </div>

                <div class="form-row mt-2">

                    <div class="col col-12 col-md-6">
                        <az-input 
                            icon="fas fa-search" 
                            v-model="search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="false">
                                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="expandido = !expandido">
                                        <i class="fas fa-expand-arrows-alt fa-fw" v-if="!expandido"></i>
                                        <i class="fas fa-compress-arrows-alt fa-fw" v-else></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-3">
                        <az-input
                            type="select"
                            :optionsList="$util.unidades_com_tags(true, true)"
                            optionsData="id_unidade_operacao"
                            icon="fa fa-building fa-fw"
                            placeholder="Todas as Unidades..."
                            v-model="filtro.id_unidade_operacao" />
                    </div>

                    

                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa fa-user"
                            type="select" 
                            optionsMode="aql"
                            optionsData="id_usuario"
                            optionsDisplay="search"
                            optionsName="usuarios-recepcao"
                            service="usuarios.index"
                            :optionsParm="{ perfil: 4, ativos: true }"
                            placeholder="Todos os Responsáveis..."
                            v-model="filtro.id_usuario">
                        </az-input>
                    </div>
                </div>

            </div>

        </div>

        <az-empty-state 
            v-if="!lista_exibicao.length && !lista_atendimentos.length && !lista_adiantamentos.length" 
            icon="fas fa-funnel-dollar"
            msg="Nenhum item identificado." />

        <template v-else>

            <!-- Nav tabs -->
            <ul class="nav nav-tabs" id="navId">
                <li class="nav-item">
                    <a href="#tab1Id" class="nav-link active" data-toggle="tab" role="tab">Pagamentos Não Realizados</a>
                </li>
                <li class="nav-item">
                    <a href="#tab2Id" class="nav-link" data-toggle="tab" role="tab">Pagamentos Pendentes</a>
                </li>
                <li class="nav-item">
                    <a href="#tab3Id" class="nav-link" data-toggle="tab" role="tab">Adiantamentos em Aberto</a>
                </li>
            </ul>

            <div id="lista-impressao">

                <cabecalho-generico titulo="Pagamentos Pendentes">
                    <div v-if="filtro">
                        <div>{{ $util.filtro_2_periodo(filtro) }}</div>
                        <div v-if="search">Pesquisa: {{ search }}</div>
                    </div>
                </cabecalho-generico>

                <!-- Tab panes -->
                <div class="tab-content">
                    <div class="tab-pane fade show active" id="tab1Id" role="tabpanel">

                        <div class="alert alert-info d-flex justify-content-between">
                            <div>
                                Pagamentos Não Realizados
                                <span class="badge badge-secondary ml-2">
                                    {{ lista_atendimentos.length }}
                                </span>
                            </div>
                            <div>
                                {{ $util.formatMoeda(total_geral_atd) }}
                            </div>
                        </div>

                        <div class="mb-3 mx-3">

                            <div class="row my-2 py-1 dashcard align-items-center w3-animate-opacity bg-white" v-for="(atendimento, index) in lista_atendimentos" :key="index">
                                <!-- Ação -->
                                <div class="col-12 col-md-2">
                                    <a href="#" @click.prevent="abrir_atendimento(atendimento.id_atendimento)" class="card-link">
                                        #{{ atendimento.id_atendimento }}
                                    </a>
                                    <div>
                                        {{ $util.getFormatDate(atendimento.dt_inicio) }}
                                    </div>
                                </div>
                                <!-- Identificação do Paciente -->
                                <div class="col col-12 col-md-4">
                                    <celula-dados-paciente :hor="atendimento" />
                                </div>

                                <div class="col col-12 col-md-4 d-flex justify-content-between">
                                    <div>
                                        <celula-dados-procedimento :hor="atendimento" :blockanexos="true" />
                                    </div>
                                </div>

                                <!-- Valor -->
                                <div class="col col-12 col-md-2 text-right">
                                    {{ $util.formatMoeda(valor_total_atd(atendimento)) }}
                                    <div class="small text-muted" v-if="atendimento.usuario && atendimento.usuario.st_login">{{ atendimento.usuario && atendimento.usuario.st_login }}</div>
                                </div>
                                
                            </div>

                        </div>

                    </div>

                    <!-- Pagamentos Pendentes -->
                    <div class="tab-pane fade" id="tab2Id" role="tabpanel">

                        <div class="alert alert-info d-flex justify-content-between">
                            <div>
                                Pagamentos Pendentes
                                <span class="badge badge-secondary ml-2">
                                    {{ lista_exibicao.length }}
                                </span>
                            </div>
                            <div>
                                {{ $util.formatMoeda(total_geral) }}
                            </div>
                        </div>

                        <div class="mb-3 mx-3">

                            <div class="row my-2 py-1 dashcard align-items-center w3-animate-opacity bg-white" v-for="(pagamento, index) in lista_exibicao" :key="index">
                                <!-- Ação -->
                                <div class="col-12 col-md-2">
                                    <template v-if="!pagamento.id_atendimento && pagamento.dc_valor_adiantado > 0">
                                        Adiantamento: #{{ pagamento.id_pagamento_atendimento }}
                                    </template>

                                    <template v-else>
                                        <a href="#" @click.prevent="abrir_atendimento(pagamento.id_atendimento)" class="card-link">
                                            #{{ pagamento.id_atendimento }}
                                        </a>
                                        <div v-if="pagamento.marcacao">
                                            {{ $util.getFormatDate(pagamento.marcacao.dt_inicio) }}
                                        </div>
                                    </template>
                                </div>
                                <!-- Identificação do Paciente -->
                                <div class="col col-12 col-md-4">
                                    <celula-dados-paciente :hor="pagamento" />
                                </div>

                                <div class="col col-12 col-md-4 d-flex justify-content-between">
                                    <div>
                                        <celula-dados-procedimento :hor="pagamento" :blockanexos="true" v-if="pagamento && pagamento.marcacao && pagamento.marcacao.procedimento" />
                                    </div>

                                    <!-- Menu de opções -->
                                    <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2" v-if="false">
                                        <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false">
                                            <i class="fas fa-ellipsis-v"></i>
                                        </a>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <button class="dropdown-item" @click="ver_informacoes(item[0])">
                                                Informações
                                            </button>
                                            <button class="dropdown-item" @click="log_laudo(item[0])">
                                                Log
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Valor -->
                                <div class="col col-12 col-md-2 text-right">
                                    {{ $util.formatMoeda(valor_total(pagamento)) }}
                                    <router-link :to="{ path: '/recepcao/pagamentos/' + pagamento.id_paciente }" class="btn btn-primary btn-sm ml-2">
                                        Pagar
                                    </router-link>
                                </div>
                                
                            </div>

                        </div>

                    </div>

                    <!-- Adiantamentos em Aberto -->
                    <div class="tab-pane fade" id="tab3Id" role="tabpanel">

                        <div class="alert alert-info d-flex justify-content-between">
                            <div>
                                Adiantamentos em Aberto
                                <span class="badge badge-secondary ml-2">
                                    {{ lista_adiantamentos.length }}
                                </span>
                            </div>
                            <div>
                                {{ $util.formatMoeda(total_saldo_adiantamento) }}
                            </div>
                        </div>

                        <table class="table bg-white">
                            <thead>
                                <tr>
                                    <table-th title="Id" v-model="ordem_adiant_abertos" sortby="id_pagamento_atendimento" width="15%"></table-th>
                                    <table-th title="Paciente" v-model="ordem_adiant_abertos" sortby="paciente.st_nome" width="30%"></table-th>
                                    <table-th title="Data" v-model="ordem_adiant_abertos" sortby="dt_data" width="15%"></table-th>
                                    <table-th title="Valor" v-model="ordem_adiant_abertos" sortby="dc_valor_adiantado" width="20%" align="text-right"></table-th>
                                    <table-th title="Saldo" v-model="ordem_adiant_abertos" sortby="saldo_adiantamento" width="20%" align="text-right"></table-th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(adiantamento, iax) in lista_adiantamentos">
                                    <tr :key="'A' + iax" :class="!adiantamento.saldo_adiantamento ? ( !adiantamento.fl_ativo ? 'table-warning' : 'table-danger' ) : ''" v-if="true">
                                        <td>
                                            <a href="#" @click.prevent="abrir_pagamento(adiantamento)" class="card-link" v-if="adiantamento.id_paciente || adiantamento.id_cadastro_temporario">
                                                #{{ adiantamento.id_pagamento_atendimento }}
                                            </a>
                                            <span v-else>
                                                #{{ adiantamento.id_pagamento_atendimento }}
                                            </span>
                                            <span class="badge badge-light ml-1" v-if="adiantamento.unidade_operacao">
                                                {{ adiantamento.unidade_operacao.st_sigla }}
                                            </span>
                                            <span v-if="adiantamento.st_id_externo" class="small text-muted ml-3">
                                                Pag.: {{ adiantamento.st_id_externo }}
                                            </span>
                                        </td>
                                        <td>
                                            <span v-if="adiantamento.paciente">
                                                {{ adiantamento.paciente.st_nome }}
                                            </span>
                                            <span v-else-if="adiantamento.cadastro_temporario">
                                                {{ adiantamento.cadastro_temporario.st_nome }}
                                            </span>
                                            <span v-else-if="adiantamento.fornecedor">
                                                <a href="#" @click.prevent="abrir_pagamento(adiantamento)" class="card-link">
                                                    {{ adiantamento.fornecedor.search }}
                                                </a>
                                            </span>
                                        </td>
                                        <td>
                                            {{ $util.getFormatDate(adiantamento.dt_data) }}
                                            <div class="small text-muted" v-if="adiantamento.orcamentos && adiantamento.orcamentos.length">
                                                Orçamento: 
                                                <a href="#" @click.prevent="abrir_orcamento(orc)" class="card-link mr-2" v-for="(orc, iox) in adiantamento.orcamentos" :key="iox">
                                                    #{{ orc.id_orcamento }}
                                                </a>
                                            </div>
                                        </td>
                                        <td class="text-right">
                                            {{ $util.formatMoeda(adiantamento.dc_valor_adiantado) }}
                                            <div v-if="adiantamento.valor_pendente">
                                                <a href="#" @click.prevent="go_to_pendentes()">
                                                    <span class="badge badge-warning" title="Valor Pendente.">
                                                        Pendente: {{ $util.formatMoeda(adiantamento.valor_pendente) }}
                                                    </span>
                                                </a>
                                            </div>
                                        </td>
                                        <td class="text-right">
                                            {{ $util.formatMoeda(adiantamento.saldo_adiantamento) }}

                                            <span v-if="adiantamento.saldo_adiantamento > 0">
                                                <i class="fas fa-door-open fa-fw ml-2"></i>
                                            </span>

                                            <span v-else>
                                                <i class="fas fa-door-closed fa-fw ml-2"></i>
                                            </span>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                            <tfoot v-if="false">
                                <tr>
                                    <th width="50%" colspan="2">Total</th>
                                    <th width="25%" class="text-right">
                                        {{ $util.formatMoeda(total_valor_adiantamento) }} 
                                    </th>
                                    <th width="25%" class="text-right">
                                        {{ $util.formatMoeda(total_saldo_adiantamento) }}
                                    </th>
                                </tr>
                            </tfoot>
                        </table>

                        <pre class="mt-3" v-if="false">{{ lista_adiantamentos }}</pre>
                    </div>
                </div>

            </div>

        </template>

        <table class="table bg-white" v-if="false">
            <pre>{{ lista_exibicao }}</pre>
        </table>

    </div>
</template>

<script>
import _ from 'lodash';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import CelulaDadosPaciente from "../../shared/table/CelulaDadosPaciente.vue";
import CelulaDadosProcedimento from "../../shared/table/CelulaDadosProcedimento.vue";
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import TableTh from '../../shared/table/TableTh.vue';

export default {
    data() { 
        return { 
            dados: null, 
            search: "", 
            expandido: false, 
            viewMode: "A",
            fornecedores: [], 
            paciente: "", 
            filtro: { 
                periodo: "do", 
                id_forma_pagamento: "98", 
                id_unidade_operacao: this.$util.getCookie('id_unidade_operacao')
                    ? this.$util.getCookie('id_unidade_operacao')
                    : '', 
                id_usuario: "", 
            },
            ordem_adiant_abertos: "", 
        }
    },

    components: { 
        AzEmptyState, 
        AzInput, 
        AzPeriodo, 
        CelulaDadosPaciente, 
        CelulaDadosProcedimento,
        PrintExport, 
        CabecalhoGenerico,
        TableTh,
    }, 

    computed: { 
        lista_exibicao: function () { 
            if ( !this.dados ) { 
                return [];
            }

            let reg = this.$util.getregex(this.search);

            return this.dados.realizados.filter(item => 
                ( !this.search || reg.test(JSON.stringify(item)))
            );
        },

        lista_atendimentos: function () { 
            if ( !this.dados ) { 
                return [];
            }

            let reg = this.$util.getregex(this.search);

            return this.dados.atendimentos.filter(item => 
                ( !this.search || reg.test(JSON.stringify(item)))
            );
        },

        lista_adiantamentos: function () { 
            if ( !this.dados || !this.dados.adiantamentos ) { 
                return [];
            }

            let reg = this.$util.getregex(this.search);

            let items = this.dados.adiantamentos.filter(item => 
                ( !this.search || reg.test(JSON.stringify(item)))
            );

            if ( this.ordem_adiant_abertos ) { 
                items = _.sortBy(items, (item) => { 
                    return _.get(item, this.ordem_adiant_abertos.name );
                });

                if ( this.ordem_adiant_abertos.direction == 'desc' ) {
                    items = _.reverse(items); 
                }
            } 

            return items;
        },

        total_geral_atd: function () { 
            return this.lista_atendimentos.flatMap(item => item.atendimento_procedimentos)
                .reduce((total, carry) => { 
                    return total + carry.cd_valor_total;
                }, 0);
        },

        total_geral: function () { 
            return this.lista_exibicao.flatMap(item => item.item_pagamento_atendimentos)
                .reduce((total, carry) => { 
                    return total + carry.dc_valor;
                }, 0);
        }, 

        total_saldo_adiantamento: function () { 
            return this.lista_adiantamentos.reduce((total, carry) => { 
                return total + carry.saldo_adiantamento;
            }, 0);
        },
    },

    methods: { 
        abrir_pagamento(adiantamento) { 
            if ( adiantamento.id_paciente ) { 
                this.$router.push({ name: 'pagamentos', params: { idpaciente: adiantamento.id_paciente }});
            } else if ( adiantamento.id_fornecedor ) { 
                this.$router.push({ name: 'pagamentos', params: { idfornecedor: adiantamento.id_fornecedor }});
            } else { 
                this.$router.push({ name: 'pagamentos', params: { idpaciente: 'p' + adiantamento.id_cadastro_temporario }});
            }
        },

        abrir_orcamento(orcamento) { 
            this.$router.push({ name: 'rorcamento', params: { id_orcamento: orcamento.id_orcamento }});
        },

        abrir_atendimento (id) { 
            this.$util.abrir_atendimento(this, id);
        },

        valor_total(pagamento) { 
            if ( !pagamento || !pagamento.item_pagamento_atendimentos ) { 
                return 0;
            }

            return pagamento.item_pagamento_atendimentos.reduce((total, carry) => { 
                return total + carry.dc_valor;
            }, 0);
        },

        valor_total_atd(atendimento) { 
            if ( !atendimento || !atendimento.atendimento_procedimentos ) { 
                return 0;
            }

            return atendimento.atendimento_procedimentos.reduce((total, carry) => { 
                return total + carry.cd_valor_total;
            }, 0);
        },

        load() { 
            this.$util.load(this, { 
                service: 'pagamentos', 
                func: 'index', 
                parms: { 
                    ...this.filtro, 
                    id_paciente: this.paciente ? this.paciente.id_pessoa : null, 
                    pendentes: true, 
                }
            });
        },

        editar (item) { 
            this.$refs.lancamento.editar(item);
        },
    },

    mounted() { 

        if ( this.$route.path == '/recepcao/pendentes' ) {

            this.$store.commit("setBreadcrumb", [
                { name: "Recepção", path: "/recepcao" },
                { name: "Pagamentos Pendentes", path: this.$route.path }
            ]);

        } else { 

            this.$store.commit("setBreadcrumb", [
                { name: "Financeiro", path: "/financeiro/visao" },
                { name: "Pagamentos Particulares Pendentes", path: this.$route.path }
            ]);

        }

        this.load();
    }
}
</script>